import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SIGN_VALIDATION_ERROR_SAMPLE_RATE = createFcmDetails('sign_validation_error_sample_rate', {
	owner: 'supporters pack',
	context: 'petition page',
	description: `Sampling rate for which the sign_validation_error event should be tracked.
			For instance, if value is 30, 30% of the sign_validation_error events will be tracked.
			Default value is 15.
		`,
	import: false,
});
